import { cn } from 'components/UI/cn'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  useCarousel,
} from 'components/UI/Carousel/Carousel'
import { Button } from 'components/UI/button'
import { AddLogoCard, LogoCard } from './LogoCard'
import { CompanyLogo } from 'models/companies'

function CustomCarouselPrevious({
  className,
  variant = 'outline',
  size = 'icon',
  ...props
}: React.ComponentProps<typeof Button>) {
  const { orientation, scrollPrev, canScrollPrev } = useCarousel()

  return (
    <Button
      data-slot="carousel-previous"
      variant={variant}
      size={size}
      className={cn(
        'absolute size-8 rounded-none w-[40px] h-[170px] ml-12',
        orientation === 'horizontal'
          ? 'top-1/2 -left-12 -translate-y-1/2'
          : '-top-12 left-1/2 -translate-x-1/2 rotate-90',
        canScrollPrev ? 'visible' : 'invisible',
        className
      )}
      disabled={!canScrollPrev}
      onClick={scrollPrev}
      {...props}
    >
      <ChevronLeft />
      <span className="sr-only">Previous slide</span>
    </Button>
  )
}

function CustomCarouselNext({
  className,
  variant = 'outline',
  size = 'icon',
  ...props
}: React.ComponentProps<typeof Button>) {
  const { orientation, scrollNext, canScrollNext } = useCarousel()

  return (
    <Button
      data-slot="carousel-next"
      variant={variant}
      size={size}
      className={cn(
        'absolute size-8 rounded-none w-[40px] h-[170px] mr-12',
        orientation === 'horizontal'
          ? 'top-1/2 -right-12 -translate-y-1/2'
          : '-bottom-12 left-1/2 -translate-x-1/2 rotate-90',
        canScrollNext ? 'visible' : 'invisible',
        className
      )}
      disabled={!canScrollNext}
      onClick={scrollNext}
      {...props}
    >
      <ChevronRight />
      <span className="sr-only">Next slide</span>
    </Button>
  )
}

function LogoCarousel({ logos }: { logos?: Array<CompanyLogo> }) {
  return (
    <Carousel
      opts={{
        align: 'start',
      }}
      className="lg:w-[73%] xl:w-[80%] 2xl:w-[95%]"
    >
      <CarouselContent className="py-2">
        {logos?.map((logo) => (
          <CarouselItem key={logo.id} className="basis-auto">
            <LogoCard logo={logo} />
          </CarouselItem>
        ))}
        {logos && logos.length < 5 ? (
          <CarouselItem className="basis-auto">
            <AddLogoCard />
          </CarouselItem>
        ) : null}
      </CarouselContent>
      <CustomCarouselPrevious />
      <CustomCarouselNext />
    </Carousel>
  )
}

export { LogoCarousel }
